export default __webpack_public_path__ + "static/media/stock-market-circle.d56ed8f4.png";